import React, {useEffect, useMemo, useReducer, useState} from 'react';
import {Redirect, useRouteMatch} from "react-router-dom";
import {getNavigationUrl} from '../../navigation';
import AppBar from "../../Components/AppBar";
import {useShoppingCart} from "../../hooks/shoppingcart";
import DeleteOrderLineDialog from "../EditProduct/Components/DeleteOrderLineDialog";
import Box from "@material-ui/core/Box";
import {Trans, useTranslation} from "react-i18next";
import BottomMenu from "./Components/BottomMenu";
import PhotogiftItemList from "./Components/PhotogiftItemList";
import PaperCopyItemList from "./Components/PaperCopyItemList";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@material-ui/core/Button";
import MultiSelect from "./Components/MultiSelectMenu";
import Icon from "@material-ui/core/Icon";
import {FormControlLabel, FormLabel, Radio, RadioGroup} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles(theme => ({
  shoppingCartContentContainer: {
    paddingBottom: '96px',
    '& h3': {
      fontSize: '15px',
      textAlign: 'center',
      textTransform: 'uppercase',
      marginTop: 0
    }
  },
  header: {
    fontSize: '24px',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  card: {
    backgroundColor: 'white',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    boxShadow: '0px 2px 4px #00000029',
  }
}))

export const ACTIONS = {
  SET_ITEMS: 'set-items',
  SET_FORMAT: 'set-format',
  SET_QUANTITY: 'set-quantity',
  SET_FILTER: 'set-filter',
  TOGGLE_DELETED: 'toggle-deleted',
}

const cartReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_ITEMS:
      return action.items;
    case ACTIONS.SET_FORMAT:
      return state.map ( (item) => {
        if (action.orderLines.find(ol => ol.uuid == item.uuid)) {
            return {
              ...item,
              dirty: true,
              name: action.format.name,
              product: action.format,
            }
        }
        return item;
      })
    case ACTIONS.SET_QUANTITY:
      return state.map ( (item) => {
        if (action.orderLines.find(ol => ol.uuid == item.uuid)) {
          return {
            ...item,
            dirty: true,
            quantity: action.quantity
          }
        }
        return item;
      })
    case ACTIONS.SET_FILTER:
      return state.map ( (item) => {
        if (action.orderLines.find(ol => ol.uuid == item.uuid)) {
          return {
            ...item,
            dirty: true,
            image: {
              ...item.image,
              filter: action.filter
            }
          }
        }
        return item;
      })
    case ACTIONS.TOGGLE_DELETED:
      let deleted = true;
      if (action.orderLines.length > 0) {
        console.log('Setting deleted', action.orderLines[0]);
        deleted = !action.orderLines[0].deleted;
      }
      return state.map ( (item) => {
        if (action.orderLines.find(ol => ol.uuid == item.uuid)) {
          console.log('Setting deleted', deleted);
          return {
            ...item,
            dirty: true,
            deleted: deleted
          }
        }
        return item;
      })
  }
}

export default () => {
  const {items, totalPrice,loading, deleteItem, updateMultipleOrderLines} = useShoppingCart();
  const [deleteOrderLine, setDeleteOrderLine] = useState(null);
  const routeMatch = useRouteMatch()
  const [selectMode, setSelectMode] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const classes = useStyles();
  const [t] = useTranslation();

  const photogiftItems = useMemo(() => {
      return items.filter(item => item.product.type != 0);
  }, [items]);

  const paperCopyItems = useMemo(() => {
    return items.filter(item => item.product.type == 0);
  }, [items]);

  const [localPaperCopyItems, dispatch] = useReducer(cartReducer, paperCopyItems)

  const totalQuantity = useMemo ( () => {
    return items.reduce ( (total, item) => {
      return total + item.quantity;
    }, 0)
  }, [items]);

  useEffect( () => {
    if (!selectMode) {
      setSelectedItems([]);
    }
  }, [selectMode])

  useEffect( () => {
    // Server side cart changed:
    dispatch({
      type: ACTIONS.SET_ITEMS,
      items: paperCopyItems
    })
  }, [paperCopyItems])

  if (loading) {
    return <div>Loading</div>
  }

  if (items.length == 0) {
    return <Redirect to={getNavigationUrl('PRODUCT_CATEGORIES')} />
  }

  const handleDelete = (e, orderLine) => {
      e.stopPropagation();
      e.preventDefault();
    setDeleteOrderLine(orderLine)
  }

  const handleMultiUpdate = () => {
    const orderLines = localPaperCopyItems
        .filter(ol => ol.dirty);
    updateMultipleOrderLines(orderLines);
    setSelectMode(false);
  }

  const handleToggleMultiUpdate = () => {
    setSelectMode( sm => !sm);
  }

  const handleToggleSelectAll = () => {
    setSelectedItems(selectedItems => {
      if (selectedItems.length == localPaperCopyItems.length) {
        return [];
      }
      else {
        return localPaperCopyItems.map(ol => ol.uuid);
      }
    })
  }

  const handleLongPress = (e, orderLine) => {
    e.stopPropagation();
    e.preventDefault();
    setSelectMode( sm => !sm);

    console.log('The order line', orderLine);

    setSelectedItems(items => {
      if (items.indexOf(orderLine.uuid) >= 0) {
        return items;
      }
      return [...items, orderLine.uuid]
    });
  }

  const handleExitSelectMode = () => {
    setSelectMode(false);
    setSelectedItems([])
  }

  const handleToggleSelected = (e, orderLine) => {
    setSelectedItems(items => {
      if (items.indexOf(orderLine.uuid) >= 0) {
        return items.filter(uuid => uuid != orderLine.uuid);
      }
      return [...items, orderLine.uuid]
    });
  }

  const doDelete = () => {
    setDeleteOrderLine(null);
    deleteItem(deleteOrderLine);
  }

  console.log('Selected items', selectedItems);

  return <Box display="flex" flexDirection='column' style={{height: '100vh'}}>
    <AppBar disableGutters />
    <h2 className={classes.header}>
      <Trans>Shopping cart</Trans>
    </h2>

    <div className={classes.shoppingCartContentContainer}>
      {photogiftItems.length > 0 && <>
            {paperCopyItems.length > 0 && <h3><Trans>Photo gifts</Trans></h3>}
            <PhotogiftItemList items={photogiftItems}
                               handleLongPress={handleLongPress}
                               handleDelete={handleDelete}
                               handleToggleSelected={handleToggleSelected}
                               selectedItems={selectedItems}
                               selectMode={selectMode}
                               scrollToItemUuid={routeMatch.params.orderPartUuid}
            />
          </>
          }

      {localPaperCopyItems.length > 0 && <>
        {photogiftItems.length > 0 && <h3><Trans>Prints</Trans></h3>}
        { localPaperCopyItems.length > 1 && <>
          { selectMode ?
              <div className={classes.card} >
                  <Radio onClick={handleToggleSelectAll} checked={localPaperCopyItems.length == selectedItems.length} color='secondary' />
                  <FormLabel onClick={handleToggleSelectAll}>{t('Select all')}</FormLabel>
              </div>
              : <Box display='flex' justifyContent='center' mb={2}>
                <Button variant='outlined' color='primary' onClick={handleToggleMultiUpdate}
                        startIcon={<Icon>filter_none</Icon>} size='small'>
                  <Trans>Adjust multiple pictures</Trans>
                </Button>
              </Box>}
          </>
          }
        <PaperCopyItemList items={localPaperCopyItems}
                           handleLongPress={handleLongPress}
                           handleDelete={handleDelete}
                           handleToggleSelected={handleToggleSelected}
                           selectedItems={selectedItems}
                           selectMode={selectMode}
                           scrollToItemUuid={routeMatch.params.orderPartUuid}
        />
      </>}
    </div>
    {selectMode && <MultiSelect dispatch={dispatch} orderLines={localPaperCopyItems}
                                selectedItems={selectedItems} onClose={handleExitSelectMode}
                                handleUpdate={handleMultiUpdate} paperCopyItems={paperCopyItems}
    />}
    {!selectMode && <BottomMenu totalQuantity={totalQuantity} totalPrice={totalPrice}/> }
    <DeleteOrderLineDialog open={!!deleteOrderLine} handleOk={doDelete}
                           handleCancel={() => setDeleteOrderLine(null)} />
  </Box>
}

